/* istanbul ignore file */

import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash/fp';

const selectSlice = get('applicationConfig');

export const selectZendeskContactUsUrl = createSelector(
    selectSlice,
    get('config.metrics.ui.zendesk.contactUs.url')
);

const selectZendeskContactUsEnabledAsString = createSelector(
    selectSlice,
    get('config.metrics.ui.zendesk.contactUs.enabled')
);
export const selectZendeskContactUsEnabled = createSelector(
    selectZendeskContactUsEnabledAsString,
    (enabled) => enabled === 'true'
);

export const selectIsSetOverrideConfigLoading = createSelector(
    selectSlice,
    get('isSetOverrideConfigLoading')
);

export const selectMaximumDatasetValueLength = createSelector(
    selectSlice,
    get('config.dataset.maximum-value-length')
);

export const selectAdvancedConfiguration = createSelector([selectSlice], ({ connection }) => {
    const { config } = connection;

    if (config === null) {
        return null;
    }

    return Object.fromEntries(Object.entries(config).sort());
});

const selectFlags = createSelector(selectSlice, get('config.feature'));

export const selectIsSlackEnabled = createSelector(selectFlags, get('slack'));

export const selectIsOpenAIEnabled = createSelector(selectFlags, get('openai'));

export const selectIsJobManagementEnabled = createSelector(selectFlags, get('module.jobs'));

export const selectIsUsageReportingEnabled = createSelector(
    selectFlags,
    get('module.cost-and-usage')
);

export const selectIsDataQualityEnabled = createSelector(selectFlags, get('module.data-quality'));

export const selectIsNoFieldDelimiterForUploadEnabled = createSelector(
    selectFlags,
    get('fileupload-no-field-delimiter')
);

export const selectIsMigrationEnabled = createSelector(selectFlags, get('module.migration'));

export const selectIsLicenseWarningBannerEnabled = createSelector(
    selectFlags,
    get('license-warning-banner')
);

export const selectIsBlendDisabled = createSelector(selectFlags, get('disable-blend'));
